<template>
  <div class="teacher-permission-bind">
    <el-dialog
      title="教师班级数据权限分配"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      width="580px"
      center
    >
      <div>
        <el-form>
          <el-form-item label="教师姓名:" prop="teacherName">
            <el-input
              v-model="teacherInfo.teacherName"
              :disabled="true"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="班级权限:" prop="teacherPermission">
            <div class="permission">
              <el-collapse v-model="activeName" accordion>
                <el-collapse-item
                  :title="item.gradeName"
                  :name="item.gradeId"
                  v-for="item in gradeList"
                  :key="item.gradeId"
                >
                  <div class="title" v-if="item.schoolClassList.length != 0">
                    <span>查询</span>
                    <span>添加</span>
                    <span>修改</span>
                    <span>删除</span>
                    <span>班级|权限</span>
                  </div>
                  <div v-if="item.schoolClassList.length != 0">
                    <div
                      class="title classList"
                      v-for="itemC in item.schoolClassList"
                      :key="itemC.classId"
                    >
                      <el-checkbox
                        v-for="(value, key) in filteredCheckList(
                          itemC.checkList
                        )"
                        :key="key"
                        v-model="itemC.checkList[key]"
                        @change="isCheckedChange(itemC.checkList, key)"
                        >{{
                          key == "isChecked" ? itemC.className : ""
                        }}</el-checkbox
                      >
                      <!-- <el-checkbox
                        v-model="itemC.checkList.isChecked"
                        @change="isCheckedChange(itemC.checkList)"
                        >{{ itemC.className }}</el-checkbox
                      >
                      <el-checkbox
                        v-model="itemC.checkList.isAdd"
                      ></el-checkbox>
                      <el-checkbox
                        v-model="itemC.checkList.isEdit"
                      ></el-checkbox>
                      <el-checkbox
                        v-model="itemC.checkList.isDelete"
                      ></el-checkbox>
                      <el-checkbox
                        v-model="itemC.checkList.isView"
                      ></el-checkbox> -->
                    </div>
                  </div>
                  <div v-else>暂无班级信息</div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button
          type="primary"
          @click="confirm()"
          v-hasPermi="'sc:classpower:edit'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    teacherInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    gradeList: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  inject: ["refresh"],
  data() {
    return {
      formLabelWidth: "120px",
      inputVisible: false,
      inputValue: "",
      activeName: "1",
    };
  },
  computed: {
    filteredCheckList() {
      return function (checkList) {
        const filtered = {};
        for (const key in checkList) {
          if (typeof checkList[key] === "boolean") {
            filtered[key] = checkList[key];
          }
        }
        return filtered;
      };
    },
  },
  mounted() {
    this.getClasspowerList();
  },
  methods: {
    isCheckedChange(e, keyName) {
      // console.log(e, keyName);
      // 遍历 e 对象的所有属性键
      for (const key in e) {
        if (keyName == "isChecked") {
          // 将属性值设置为与 e.isChecked 相同
          if (typeof e[key] === "boolean") {
            e[key] = e.isChecked;
          }
        }
      }

      // 判断是否所有属性（除了 isChecked）都为 true
      let allTrue = true;
      for (const key in e) {
        if (key !== "isChecked" && e.hasOwnProperty(key)) {
          if (!e[key] && typeof e[key] === "boolean") {
            allTrue = false;
            break;
          }
        }
      }

      // 根据 allTrue 设置 isChecked
      e.isChecked = allTrue;
    },
    getClasspowerList() {
      let PermissionBindArray = [];
      this.get(
        this.$url.getClasspowerList + "?teacherId=" + this.teacherInfo.id
      ).then((res) => {
        // console.log("查询教师绑定权限==>", res);
        PermissionBindArray = res.data.map((item) => {
          const PermissionBindItem = { ...item }; // Create a shallow copy of the object
          let allTrue = true;

          for (const key in PermissionBindItem) {
            if (
              !PermissionBindItem[key] &&
              typeof PermissionBindItem[key] === "boolean"
            ) {
              allTrue = false;
            }
            PermissionBindItem[key] =
              PermissionBindItem[key] == 1
                ? true
                : PermissionBindItem[key] == 0
                ? false
                : PermissionBindItem[key];
          }
          PermissionBindItem["isChecked"] = allTrue;

          return PermissionBindItem;
        });

        for (const gradeItem of this.gradeList) {
          for (const classItem of gradeItem.schoolClassList) {
            classItem.checkList = {
              classId: classItem.classId,
              isView: false,
              isAdd: false,
              isEdit: false,
              isDelete: false,
              isChecked: false,
            };
            for (const permissionItem of PermissionBindArray) {
              if (classItem.classId === permissionItem.classId) {
                classItem.checkList = permissionItem;
                break; // Stop searching once a match is found
              }
            }
          }
        }
      });
    },
    dialogOpen() {},
    dialogClose() {
      this.$emit("update:dialogVisible", false);
    },
    confirm() {
      let data = [];
      // console.log(this.gradeList);
      this.gradeList.forEach((item) => {
        item.schoolClassList.forEach((itemC) => {
          for (const key in itemC.checkList) {
            if (
              typeof itemC.checkList[key] !== "number" &&
              itemC.checkList[key] === true
            ) {
              (itemC.checkList["teacherId"] = this.teacherInfo.id),
                data.push(itemC.checkList);
              break;
            }
          }
        });
      });
      this.$emit("insertClassPower", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher-permission-bind.scss";
</style>
